import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Layout as AntLayout, Menu, Button, Drawer } from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';
const { Header, Content } = AntLayout;
const StyledLayout = styled(AntLayout) `
  min-height: 100vh;
`;
const StyledHeader = styled(Header) `
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  background: #fff;
  border-bottom: 1px solid #f0f0f0;
`;
const Logo = styled.div `
  font-size: 20px;
  font-weight: bold;
  color: #1890ff;
`;
export const Layout = ({ title, children, menuItems = [] }) => {
    const [drawerVisible, setDrawerVisible] = React.useState(false);
    const toggleDrawer = () => {
        setDrawerVisible(!drawerVisible);
    };
    const renderMenu = () => (_jsx(Menu, { mode: "inline", defaultSelectedKeys: ['dashboard'], items: menuItems.map(item => ({
            key: item.key,
            icon: item.icon,
            label: item.label,
            onClick: item.onClick,
        })) }));
    return (_jsxs(StyledLayout, { children: [_jsx(StyledHeader, { children: _jsxs("div", { style: { display: 'flex', alignItems: 'center' }, children: [menuItems.length > 0 && (_jsx(Button, { type: "text", icon: _jsx(MenuOutlined, {}), onClick: toggleDrawer, style: { marginRight: 16 } })), _jsx(Logo, { children: title })] }) }), _jsx(Drawer, { title: title, placement: "left", onClose: toggleDrawer, open: drawerVisible, width: 256, children: renderMenu() }), _jsx(Content, { style: { padding: '24px', minHeight: 280 }, children: children })] }));
};
// Export a "basic" layout for simple use-cases
export { ResponsiveLayout as BasicResponsiveLayout } from './ResponsiveLayout';
// Export the full-featured responsive layout under the canonical name expected by apps
export { ResponsiveLayout as ResponsiveLayout } from './ResponsiveLayoutPro';
//# sourceMappingURL=index.js.map